import { Component } from "@angular/core";
import { CustomFilterCell } from '../../classes/custom-filter-cell';
import { FilterService } from '@progress/kendo-angular-grid';

@Component({
    selector: 'chassis-datatable-boolean-filter-cell',
    templateUrl: './boolean.component.html',
    styleUrls: ['./boolean.component.scss'],
})
export class BooleanComponent extends CustomFilterCell {

    constructor(
        filterService: FilterService
    ) {
        super(filterService);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/components/filters/row/boolean/boolean.component.ts